/** Permission codes gating contact and facility-link writes (shared by both lists). */
export const CONTACT_UPDATE_PERMISSION = 'update__healthcare_entities__contact';
export const CONTACT_DELETE_PERMISSION = 'delete__healthcare_entities__contact';
export const LINK_CREATE_PERMISSION = 'create__healthcare_entities__facilitycontact';
export const LINK_UPDATE_PERMISSION = 'update__healthcare_entities__facilitycontact';
export const LINK_DELETE_PERMISSION = 'delete__healthcare_entities__facilitycontact';
